// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MKN7g","newExpiryDate":"styles_newExpiryDate__3UKl8","footer":"styles_footer__30xLz"};